import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { StringConst } from 'src/app/constants/const';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-hoffman-confirm-dialog',
  templateUrl: './hoffman-confirm-dialog.component.html',
  styleUrls: ['./hoffman-confirm-dialog.component.scss']
})
export class HoffmanConfirmDialogComponent implements OnInit {

  text = StringConst.empty;
  constructor(
    @Inject(MAT_DIALOG_DATA) private hoffmanText: string,
    private matDialogRef: MatDialogRef<HoffmanConfirmDialogComponent>,
    private commonService: CommonService
  ) { }

  ngOnInit(): void {
    this.text = `Producto ${this.hoffmanText.charAt(0).toLocaleLowerCase()}${this.hoffmanText.slice(1)}`;
  }

  continue(): void {
    this.matDialogRef.close(true);
  }
}
